import { render, staticRenderFns } from "./sortRight.vue?vue&type=template&id=065a19cb&scoped=true"
import script from "./sortRight.vue?vue&type=script&lang=js"
export * from "./sortRight.vue?vue&type=script&lang=js"
import style0 from "./sortRight.vue?vue&type=style&index=0&id=065a19cb&prod&scoped=true&lang=css"
import style1 from "./sortRight.vue?vue&type=style&index=1&id=065a19cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a19cb",
  null
  
)

export default component.exports